define('env',['jquery'], function env ($) {

    // Get environment from url and setup global config object
    // Example: local-console.evertrue.com is the 'local' environment
    var configure = function() {
        var urlParts = window.location.host.split('-'),
            urlOrigin = window.location.origin || (window.location.protocol + "//" + window.location.host),
            environment = urlParts.length > 1 ? "stage" : "production",
            apiPrefix = (environment == "production") ? "api" : "stage-api"
            config = {
                app_keys: {
                    console: "89567e74bec3afafc5f46db72b1a9323f41858256e3bec5dc9e522a7b3f3518f",
                    community: "590b6855ec417400015682e454c6acec8f371adf861b830b031fa9ad3ac84c90",
                    volunteers: "7cb9b8d4451567b725e81b998cdf46cfc58426f9936916c714acddbc9f082546",
                    givingtree: "815e8d01be8f78a41d1c71eb652b8be124b89058b74d284c6bb752a034dbb301"
                },
                DEBUG: false,
                apiBase: "https://" + apiPrefix + ".evertrue.com/",
                wwwBase: urlOrigin + "/",
                webBase: urlOrigin.replace("console", "web") + "/",
                accountsBase: urlOrigin.replace("console", "accounts") + "/",
                local: false,
                developer: false,
                givingTreeBase: "https://app.evertrue.com/",
                disableFsConsole: false
            };

        if (environment != 'production') {
            config.sandbox = environment;
            config.DEBUG = true;
            config.developer = true;
            config.givingTreeBase = "https://stage-app.evertrue.com/";
            config.cookie_prefix = "stage_"
        }

        // If there is a dev_env.json file, override the config if required
        // Local Environment Configs will not work with landing pages
        $.getJSON("/config/local_env.json", function(data){
            var env = data.environment;
            if (env) {
                _.extend(config, data.configs[env]);
            }
        });

        return config;
    };

    return {configure: configure};

});

